module.exports = __webpack_public_path__ + "media/images/icons/download-74fb257c01b37687141ec083e0ffb7f6.svg";